import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Typography } from '@mui/material';

interface Props {
  children: JSX.Element;
  text: string;
  opened?: boolean;
  isTeam?: boolean;
}

const MenuListGroup = ({ children, text, opened = true, isTeam }: Props) => {
  const [openSquadItem, setOpenSquadItem] = useState(opened);

  const onOpenSquadItem = () => {
    setOpenSquadItem(!openSquadItem);
  };

  return (
    <>
      <Button
        variant="outlined"
        fullWidth
        endIcon={!openSquadItem ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
        sx={{
          justifyContent: 'flex-start',
          color: '#FFF',
          borderRadius: '6px',
          border: 0,
          fontSize: '14px',
          lineHeight: '14px',
          textTransform: 'none',
          py: 1.4,
          px: isTeam ? 3 : 5,
        }}
        onClick={onOpenSquadItem}
      >
        <Typography
          variant="body2"
          sx={{
            flex: '1 1 auto',
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
          }}
        >
          {text}
        </Typography>
      </Button>
      <Collapse
        sx={{
          minHeight: 'auto',
          p: 1,
          background: isTeam ? 'none' : 'rgba(7, 34, 72, 1)',
        }}
        in={openSquadItem}
        timeout="auto"
        unmountOnExit
      >
        {children}
      </Collapse>
    </>
  );
};

export default MenuListGroup;
